module.exports = __webpack_public_path__ + "img/588.5673fe9d.jpg";